import React, {Component} from 'react';
import PropTypes from 'prop-types';
import styled from "styled-components";

import {DEFAULT_ZOOM_LOG} from './TrackZoom.jsx';

const ActionItem = styled.div`
    border-radius: 0.5rem;    
    overflow:hidden;
    position:absolute;
`;

export class TrackAction extends Component {

    static propTypes = {
        action: PropTypes.object.isRequired,
        event: PropTypes.object.isRequired,
        hsl: PropTypes.object.isRequired,
        top_rem: PropTypes.number.isRequired,
        height_rem: PropTypes.number.isRequired,
    }

    state = {
        intensity: false,
        base_style: {},
        base_color: '',
        active_color: '',
        inner_style: {}
    };

    componentDidMount() {
        const base_color = 'hsl(' + this.props.hsl.h + ', 30%, ' + this.props.hsl.l / 2 + '%)';
        const active_color = 'hsl(' + this.props.hsl.h + ', 85%, ' + this.props.hsl.l + '%)';
        const base_style = {
            height: this.props.height_rem + 'rem',
            top: this.props.top_rem + 'rem',
            zIndex: Math.floor(this.props.event.timecode * 1.0),
            // boxShadow: Colors.wide_raw_shadow(30),
        }
        const zoom_factor = Math.exp(DEFAULT_ZOOM_LOG);
        this.set_zoom(zoom_factor, base_style);
        this.setState({
            base_style: base_style,
            base_color: base_color,
            active_color: active_color,
        });
    }

    set_zoom(zoom_factor, base_style = this.state.base_style) {
        let inner_style = {
            left: 1 + (this.props.event.timecode / zoom_factor) + 'px',
            width: (this.props.action.duration_ms / zoom_factor) + 'px'
        }
        Object.assign(inner_style, base_style);
        this.setState({
            inner_style: inner_style
        });
    }

    set_intensity(intensity) {
        this.setState({intensity: intensity,});
    }

    render() {
        let item_style = {
            backgroundColor: this.state.intensity ? this.state.active_color : this.state.base_color
        };
        Object.assign(item_style, this.state.inner_style);
        return <ActionItem style={item_style}/>
    }
}

export default TrackAction;

